import { APP_BASE_HREF } from '@angular/common';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import {
  ApplicationConfig,
  importProvidersFrom,
  provideAppInitializer,
  provideZoneChangeDetection,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { BrowserModule } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter } from '@angular/router';
import { appEventConfigInitializer } from 'src/app/@configs/app-event-config.init';
import { appIconsInitializer } from 'src/app/@configs/app-icons.init';
import { appMixpanelInitializer } from 'src/app/@configs/app-mixpanel.init';
import { appRouteTrackingInitializer } from 'src/app/@configs/app-route-tracking.init';
import { appScrollTrackingInitializer } from 'src/app/@configs/app-scroll-tracking.init';
import { provideTranslocoConfig } from 'src/app/@configs/transloco.config';
import { authInterceptor } from 'src/app/@interceptors/auth.interceptor';
import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    // SYN-TH-Q2 — the ROUTER lives at the origin root, whatever `<base href>`
    // says.
    //
    // The operator build of this app is served from the admin origin so the
    // dashboard and its projector share one browser origin (COOP `same-origin`
    // severs a cross-origin popup, and Moonshine needs cross-origin isolation).
    // Its assets are namespaced under /projector-assets/ to avoid colliding
    // with the dashboard's, and `<base href>` is what does that namespacing —
    // but base href also drives route resolution, and these routes are
    // /primary-screen and /session/:id at the ROOT, not under the asset prefix.
    // Pinning APP_BASE_HREF separates the two: assets follow base href, routes
    // do not. For the audience build both are '/', so this changes nothing.
    { provide: APP_BASE_HREF, useValue: '/' },
    provideRouter(routes),
    importProvidersFrom(
      BrowserModule,
      MatIconModule,
      FormsModule,
      MatSnackBarModule
    ),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideAnimations(),
    provideAppInitializer(() => {
      const initializerFn = appEventConfigInitializer();
      return initializerFn();
    }),
    provideAppInitializer(() => {
      const initializerFn = appIconsInitializer();
      return initializerFn();
    }),
    provideAppInitializer(() => {
      const initializerFn = appMixpanelInitializer();
      return initializerFn();
    }),
    provideAppInitializer(() => {
      const initializerFn = appRouteTrackingInitializer();
      return initializerFn();
    }),
    provideAppInitializer(() => {
      const initializerFn = appScrollTrackingInitializer();
      return initializerFn();
    }),
    provideAnimationsAsync(),
    provideTranslocoConfig(),
  ],
};
